module.exports = __webpack_public_path__ + "img/lottery-icon_b.5da56373.png";